/* This validation is for Styleguide */
if (typeof window.config === 'undefined') {
  window.config = () => ({ api: '', hub: '', maxRecords: 0 });
}
const localConfig = window.config();

/**
 * Creates final url, concat business module and endpoint path
 *
 * @param {string} module - Business module
 * @param {string} path - Endpoint path and queryString
 */
const createEndpoint = (api, module, path) => `${api}/${module}/${path || ''}`;

const createMockEndpoint = (path) => `http://srv-webtn:3500/${path || ''}`;

/**
 * Provides methods used to access business endpoints
 *
 * @mixin endpoints
 */
export const endpoints = {
  /**
   * Access to Framework endpoints
   *
   * @param {string} path - Endpoint path and queryString
   */
  frameworkbo: (path) => createEndpoint(localConfig.api, 'framework_bo', path),
  framework: (path) => createEndpoint(localConfig.api, `framework`, path),
  chnn: (path) => createEndpoint(localConfig.api, 'CR_CHNN', path),
  backoffice: (path) => createEndpoint(localConfig.api, 'SIFOX_PALOP', path),
  simo: (path) => createEndpoint(localConfig.api, 'SIMO_TRLT', path),

  webservices: (path) => createEndpoint(localConfig.apiService, 'User', path),
  users: (path) => createEndpoint(localConfig.api, 'framework', path),

  mocks: (path) => createMockEndpoint(path),

  /**
   * Set number of max records returned by request
   *
   * @param {number} num - Max number of records
   */
  maxRecords: (num) =>
    Number.isInteger(num) && num > 0 ? num : localConfig.maxRecords,
};
